import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FaFilePdf } from "react-icons/fa";
import moment from "moment";
import { Button } from "reactstrap";

import { scoringResultsReportExportIsLoading } from "../../../../selectors";
import { exportScoringResultsReportCsv } from "../../../../actions";
import Spinner from "../../../../../../components/common/Spinner";
import { scoringResultTypes } from "../../../../constants/scoringResultsReportConstants";
import "./scoringReportRow.css";

const ScoringReportRow = ({ entry }) => {
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);
  const handleExport = (data) => {
    dispatch(exportScoringResultsReportCsv(data));
  };

  const isLoading = useSelector(scoringResultsReportExportIsLoading);

  return (
    <React.Fragment>
      <tr
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: isHovered ? "#DBFFED" : "#FFFFFF",
        }}
      >
        <td>
          {moment.utc(entry.createDate).local().format("DD.MM.YYYY HH:mm:ss")}
        </td>
        <td>{entry.label}</td>
        <td>
          {
            scoringResultTypes.find((option) => option.value === entry.type)
              .label
          }
        </td>
        <td className="pt-0 pb-0">
          <Button
            color="primary"
            onClick={() =>
              handleExport({ scoringInfoId: entry.id, scoringExportType: 0 })
            }
            className={
              isHovered
                ? "scoring-results-row-button visible-button float-right"
                : "scoring-results-row-button blurred-button float-right"
            }
            disabled={isLoading}
          >
            <div className="scoring-results-row-button-inner-box">
              <Spinner loading={isLoading} />
              <FaFilePdf
                size="1.3em"
                data-tip
                data-for="pdf-icon"
                color="white"
              />
              Export Successful
            </div>
          </Button>
        </td>
        <td width={170} className="pt-0 pb-0">
          <Button
            color="secondary"
            onClick={() =>
              handleExport({ scoringInfoId: entry.id, scoringExportType: 1 })
            }
            className={
              isHovered
                ? "scoring-results-row-button visible-button float-right"
                : "scoring-results-row-button blurred-button float-right"
            }
            disabled={isLoading}
          >
            <div className="scoring-results-row-button-inner-box">
              <Spinner loading={isLoading} />
              <FaFilePdf
                size="1.3em"
                data-tip
                data-for="pdf-icon"
                color="white"
              />
              Export Errors
            </div>
          </Button>
        </td>
      </tr>
    </React.Fragment>
  );
};

export default ScoringReportRow;



// WEBPACK FOOTER //
// ./src/features/reports/pages/scoring-results-report-page/scoring-results-table/row/ScoringReportRow.jsx